module.exports = __webpack_public_path__ + "img/13.3cc28f19.png";